module.exports = __webpack_public_path__ + "img/sample_map10.06b24a84.png";